<template>
  <div class="site-aside-container">
    <!-- <Avatar url="http://mdrs.yuanjin.tech/FgMwAPYq17So9nwVH44ltDHo7u3c" />  //左边上面的logo图片 -->
     <Avatar url="http://3721.fit/logo.png" />  <!-- 左边上面的logo图片 -->
    <h3 class="title"></h3>
    <Menu />
    <Contact />
    <p class="footer">
      丰列表<br>
      fengliebiao<br>
      @2019-2023
    </p>
  </div>
</template>

<script>
import Avatar from "@/components/Avatar";
import Menu from "./Menu";
import Contact from "./Contact";
export default {
  components: {
    Avatar,
    Menu,
    Contact,
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.site-aside-container {
  width: 100%;
  height: 100%;
  background: @green; //SiteAside 站点左边的背景颜色，默认颜色 background: @dark;
  padding: 20px 0;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto; //开启y轴滚动条
}
.avatar-container {
  margin: 0 auto;
}
.footer {
  text-align: center;
  font-size: 12px;
}
.title {
  font-size: 1.2em;
  color: #fff;
  text-align: center;
}
</style>
